/**
 * axios二次封装 【终极修复版 - 解决浏览器访问正常/axios请求异常】
 */
import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '../router'

const TOKEN_INVALID = 'Token认证失败，请重新登录'
const NETWORK_ERROR = '网络请求异常，请稍后重试'

// 创建axios实例对象，添加全局配置 ✔️ 保留你的所有配置
const service = axios.create({
    baseURL: window.envConfig.WHG_BASE_API,
    timeout: 5 * 60 * 1000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
})

// ✅ 修复：请求拦截器【补全失败回调】+ 规范写法
service.interceptors.request.use(
    (req) => {
        // 这里可以加token、请求头配置，比如：
        // const token = localStorage.getItem('token')
        // token && (req.headers.Authorization = token)
        return req;
    },
    (err) => {
        ElMessage.error(NETWORK_ERROR)
        return Promise.reject(err)
    }
)

// ✅ 修复：响应拦截器【全部核心错误修复】+ 业务逻辑适配 + 异常兜底
service.interceptors.response.use(
    (response) => {
        const res = response.data || {};
        console.log('接口原始返回数据：', res)
        const resObj = eval( '(' + res + ')' )
        console.log('resObj', resObj)
        // 适配你的后端返回格式 {statusCode:0, msg:"操作成功", data:{...}}
        const { statusCode, msg, data } = resObj;
        // 业务成功：后端约定的statusCode=0
        if (statusCode === 0) {
            // ✅ 修复1：成功就正常返回数据，不再抛异常！！！
            return data; 
        }
        // 业务失败：非0状态码，提示错误信息+手动抛异常
        ElMessage.error(msg || '接口请求失败，请稍后重试')
        return Promise.reject({ statusCode, msg })
    },
    // 接口HTTP请求失败（状态码401/404/500等）
    (err) => {
        ElMessage.error(NETWORK_ERROR)
        if (err.response && err.response.status === 401) {
            ElMessage.error(TOKEN_INVALID)
        }
        return Promise.reject(err)
    }
)

/**
 * 请求核心函数
 * @param {*} options 请求配置
 */
function request(options) {
    options.method = options.method || 'get'
    if (options.method.toLowerCase() === 'get') {
        options.params = options.data
    } else {
        options.data = options.data
    }
    // 重置baseURL（保留你的原有逻辑）
    service.defaults.baseURL = window.envConfig.WHG_BASE_API
    // 发送请求并返回Promise对象
    return service(options)
}

// 批量封装 get/post/put/delete/patch 请求方法（保留你的原有逻辑，无修改）
['get', 'post', 'put', 'delete', 'patch'].forEach((item) => {
    request[item] = (url, data, options) => {
        return request({
            url,
            data,
            method: item,
            ...options
        })
    }
})

export default request;